import { render, staticRenderFns } from "./Ivt.vue?vue&type=template&id=3099ab38&"
import script from "./Ivt.vue?vue&type=script&lang=js&"
export * from "./Ivt.vue?vue&type=script&lang=js&"
import style0 from "./Ivt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports